export class GlobalConstants {
    // roles
    public static internal: string = 'Intrust';
    public static specialist: string = 'Gestor Compañia';
    public static supervisor: string = 'Supervisor Compañia';
    public static manager: string = 'Gerente Compañia';
}
